import { Route, Outlet } from 'react-router-dom';
import { ProtectedRoute } from 'ProtectedRoute';
import { DisconnectedMobileInitComponent } from './components/DisconnectedMobileInitComponent';

export const DISCONNECTED_MOBILE_INIT_ROUTES = {
    DISCONNECTED_MOBILE_INIT: { path: '/disconnected-mobile-init' },
};

export function hasCordovaNoNetwork() {
    // Check if we're in Cordova environment and network bootstrap hasn't completed
    if (window.CORDOVA && !window.networkBootstrapCompleted) {
        return true;
    }
    return false;
}

export function configureDisconnectedMobileInitRoutes() {
    return [
        {
            routes: DISCONNECTED_MOBILE_INIT_ROUTES,
            config: {
                removeAppShell: true,
            },
        },
    ];
}

export function getDisconnectedMobileInitRoutes() {
    return (
        <Route id="disconnected-mobile-init-routes" element={<Outlet />}>
            <Route
                path={DISCONNECTED_MOBILE_INIT_ROUTES.DISCONNECTED_MOBILE_INIT.path}
                element={
                    <ProtectedRoute accessPolicy="custom" accessPolicyFn={hasCordovaNoNetwork}>
                        <DisconnectedMobileInitComponent />
                    </ProtectedRoute>
                }
            />
        </Route>
    );
}
